<template>
    <div id="searchView">
        <!--搜索-->
        <topSearchView  @topSearchParentReceive="topSearchParentReceiveFN"/>
        <!--内容-->
        <div class="bottomWrap">
            <!--顶部的分类选择-->
            <div class="topType">
                <div class="typeFlexBox">
                    <div 
                        class="topTypeList"
                        v-for="(item,index) in dataAll" 
                        :class="psbTypeIndex == index?'topTypeListCheck':''"
                        :key="index"
                        @click="psbTypeClick(item,index)">
                        <span v-if="item.name!='稽查案例'">{{ item.name }}</span>
                        <span v-else>稽查</span>
                    </div>
                </div>
                <!--分割-->
                <div class="divB"></div>
                <!--展示的子级列表 答疑-->
                <div class="topChildTypeDY" v-if="psbTypeIndex !=1&&psbTypeIndex !=4&&psbChildType.length!=0">
                    <div 
                        class="childTypeDYList"
                        :class="psbChildTypeIndex==index?'childTypeListCheck':''"
                        v-for="(item,index) in psbChildType" 
                        :key="index"
                        @click="psbChildTypeclick(item,index)">
                        <p class="dyChildName">{{ item.name }}</p>
                        <p class="dyChildTotal">{{ item.count }}</p>
                    </div>
                </div>
                <!--展示的子级列表 法规-->
                <div class="topChildTypeFG" v-if="psbTypeIndex==1">
                    <div 
                        class="childTypeFGList"
                        :class="psbChildTypeIndex==index?'childTypeListCheck':''"
                        v-for="(item,index) in psbChildType" 
                        :key="index"
                        @click="psbChildTypeclick(item,index)">
                        <p class="dyChildName">{{ item.name }}</p>
                        <p class="dyChildTotal">{{ item.count }}</p>
                    </div>
                </div>
                <!--展示的子级列表 税率 :class="psbChildTypeIndex==index?'childTypeListCheck':''"-->
                <div class="topChildTypeSL" v-if="psbTypeIndex ==4&&psbChildType.length!=0">
                    <div 
                        class="childTypeSLList"
                        
                        v-for="(item,index) in psbChildType" 
                        :key="index"
                        @click="psbChildTypeclickSL(item,index)">
                        <p class="dyChildName">{{ item.name }}</p>
                    </div>
                </div>
                <!--法规的效力范围-->
                <div class="fgxlfwView" v-if="psbTypeIndex==1">
                    <div class="fgxlfwViewFlex" v-loading="loadingXLFW">
                        <div 
                            class="fgxlfwList" 
                            v-for="(item,index) in fgxlfwData" 
                            :key="index"
                            :class="fgxlfwDataIndex==index?'fgxlfwListCheck':''"
                            @click="fgxlfwDataClick(item,index)"
                            >
                            <span>{{ item.name }}</span>
                            <span>{{ item.count }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!--选中的分类名-->
            <div class="checkNameBox" v-if="psbTypeIndex != 1&&psbTypeIndex != 5">
                <span>首页></span>
                <span>普适版搜索></span>
                <span :class="showTextChildName==''?'blueSpan':''">
                    {{ showTextTopName }}
                    <span v-if="showTextChildName!=''">></span>
                </span>
                <span class="blueSpan">{{ showTextChildName }}</span>
            </div>
            <!--数据列表-->
            <div class="dataView"  v-if="psbTypeIndex != 1&&psbTypeIndex != 5">
                <!--分割-->
                <div class="divB"></div>
                <!--分类名-->
                <div class="dataTopName">
                    <span v-if="showTextChildName!=''">{{ showTextChildName }}</span>
                    <span v-else>{{  showTextTopName  }}</span>
                    <span class="redSpan">（{{ dataCount }}）</span>
                </div>
                <!--列表 0-答疑  1-法规 2-解读  3-专题 4-税率 5-实务 6-案例 7-稽查-->
                <div v-if="psbTypeIndex == 0">
                    <dyListView ref="dyListView" :sendData="sendDataDY" />
                </div>
                <div v-if="psbTypeIndex == 2">
                    <jdListView ref="jdListView" :sendData="sendDataDY" />
                </div>
                <div v-if="psbTypeIndex == 3">
                    <ztListView ref="ztListView" :sendData="sendDataDY" />
                </div>
                <div v-if="psbTypeIndex == 4">
                    <slListView ref="slListView" :sendData="sendDataDY" />
                </div>
                
                <div v-if="psbTypeIndex == 6">
                    <alListView ref="alListView" :sendData="sendDataDY" />
                </div>
                <div v-if="psbTypeIndex == 7">
                    <jcListView ref="jcListView" :sendData="sendDataDY" />
                </div>
            </div>
            <div class="dataViewFG" v-if="psbTypeIndex == 1||psbTypeIndex == 5">
                <!--左侧分类-->
                <div class="dataLeftType">
                    <div class="dataLeftTypeWrap">
                        <div 
                            class="dataLeftTypeList" 
                            :class="fgLeftDataListIndex==index?'dataLeftTypeListCheck':''"
                            v-for="(item,index) in fgLeftDataList" 
                            :key="index"
                            @click="dataLeftTypeClick(item,index)">
                            <div class="leftTypeName">{{ item.name }}</div>
                            <div class="leftTypeNum">{{ item.count }}</div>
                        </div> 
                    </div>
                </div>
                <div class="dataRightCheckNameBox">
                    <span>首页></span>
                    <span>普适版搜索></span>
                    <span :class="showTextChildName==''?'blueSpan':''">
                        {{ showTextTopName }}
                        <span v-if="showTextChildName!=''">></span>
                    </span>
                    <span  :class="fgShowName==''?'blueSpan':''">{{ showTextChildName }}</span>
                    <span class="blueSpan">>{{ fgShowName }}</span>
                </div>
                <div class="fgDataWrap">
                    <fgListView ref="fgListView" :sendData="sendDataDY" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>

//引入组件
import topSearchView from '@/components/topSearch.vue'
import dyListView from './dy.vue'
import fgListView from './fg.vue'
import jdListView from './dy.vue'
import ztListView from './dy.vue'
import slListView from './dy.vue'
import alListView from './dy.vue'
import jcListView from './dy.vue'

//引入数据
import { psbSearchType } from '@/config/searchEdition.js'

//引入接口
import { HomeLaw,lawSearch } from '@/api/api.js'



export default {
    name:'',
    components:{
        topSearchView,
        dyListView,
        fgListView,
        jdListView,
        ztListView,
        slListView,
        alListView,
        jcListView
    },
    data(){
        return{
            loading:null,
            //传递的搜索分类
            searchSend:{
                searchType:0,
                inputValue:'',
                endPublicDate:'',
                startPublicDate:'',
            },
            //获取到的所有数据 普适版的分类
            dataAll:[],
            //普适版 分类的选中
            psbTypeIndex:0,
            //分类的子级的分类
            psbChildType:[],
            psbChildTypeIndex:0,
            //顶部选择的分类名称
            showTextTopName:'答疑',
            //子级选择的分类名称
            showTextChildName:'税务总局答疑',
            loadingXLFW:false,
            //法规效力范围数据
            fgxlfwDataIndex:'qwyx',
            fgxlfwData:{
                qwyx:{
                    name:'全文有效',
                    key:'qwyx',
                    count:0,
                },
                bfyx:{
                    name:'部分有效',
                    key:'bfyx',
                    count:0,
                },
                tdsjyx:{
                    name:'特定时间有效',
                    key:'tdsjyx',
                    count:0,
                },
                qwsx:{
                    name:'全文废止',
                    key:'qwsx',
                    count:0,
                },
                bfsx:{
                    name:'部分失效',
                    key:'bfsx',
                    count:0,
                },
                tdsjsx:{
                    name:'特定时间失效',
                    key:'bfxs',
                    count:123456,
                }
            },
            //法规下面的左侧列表
            fgLeftDataList:[],
            fgLeftDataListIndex:0,
            fgShowName:'',
            //展示的数据条数
            dataCount:0,
            //传递给答疑的数据
            sendDataDY:{
                listId:'',
                name:'答疑',
                special:false
            },
        }
    },
    created(){
        //默认调用答疑 下的税务总局答疑
        this.sendDataDY.listId = 4025;
        console.log(this.$route.path)
        let data = this.$route.params
        this.searchSend = data
        this.sendDataDY.searchType = data.searchType
        this.sendDataDY.inputValue = data.inputValue
        this.sendDataDY.startPublicDate = data.startPublicDate
        this.sendDataDY.endPublicDate = data.endPublicDate
        //console.log(this.$route.query)
        //获取初始展示数据
        this.getDataAll()
    },
    methods:{
        //搜索框 搜索按钮的点击 -- 子组件传递
        topSearchParentReceiveFN(data){
            console.log(data)
            this.searchSend = data
            this.sendDataDY.searchType = data.searchType
            this.sendDataDY.inputValue = data.inputValue
            this.sendDataDY.startPublicDate = data.startPublicDate
            this.sendDataDY.endPublicDate = data.endPublicDate

            if(this.psbTypeIndex == 1){
                this.getXLFW()
            }
            //获取子级分类
            this.sendRef();
            this.getDataAll();
        },
        //普适版的分类切换
        psbTypeClick(item,index){
            //console.log(item);
            //选中分类名
            this.showTextTopName = item.name;
            //选中状态
            this.psbTypeIndex = index;

            //子级选中重置
            this.showTextChildName = '';
            this.psbChildTypeIndex = 0;
            this.fgShowName = '';
            this.fgLeftDataListIndex = 0;

            //子级
            this.psbChildType = [];

            this.sendDataDY.name = this.showTextTopName;

            this.sendDataDY.special = false;
            //0答疑 1-法规 2-解读 3-专题 4-税率 5-实务  6-案例 7-稽查
            if(this.psbTypeIndex == 4){
                this.psbChildType = item.childs;
                this.dataCount = item.count;
                this.sendDataDY.listId = item.id;
                this.sendDataDY.special = true;
            }else if(this.psbTypeIndex == 6){
                this.showTextChildName = item.childs[1].name;
                this.dataCount = item.childs[1].count;
                this.sendDataDY.listId = item.childs[1].id;
            }else if(this.psbTypeIndex == 7){
                this.dataCount = item.count;
                this.sendDataDY.listId = item.id;
            }else if(this.psbTypeIndex == 5){
                this.psbChildType = item.childs;
                this.showTextChildName = item.childs[0].name;
                //this.dataCount = item.childs[0].count;
                this.fgLeftDataList = item.childs[0].childs
                this.fgShowName = item.childs[0].childs[0].name;
                //重置
                delete this.sendDataDY.states
                this.sendDataDY.tagIds = []
                //左侧分类赋值
                this.dataLeftTypeClick(item.childs[0].childs[0],0)
            }else{
                if(item.childs&&item.childs.length!=0){
                    this.psbChildType = item.childs;
                    this.showTextChildName = item.childs[0].name;
                    this.dataCount = item.childs[0].count;
                    this.sendDataDY.listId = item.childs[0].id;
                    //子级分类赋值
                    this.psbChildTypeclick(item.childs[0],0)
                }
            }
        },
        //触发子级的函数
        sendRef(){
            if(this.psbTypeIndex == 0){
                this.$refs.dyListView.getStart(this.sendDataDY)
            }
            if(this.psbTypeIndex == 1){
                this.$refs.fgListView.getStart(this.sendDataDY)
            }
            if(this.psbTypeIndex == 2){
                this.$refs.jdListView.getStart(this.sendDataDY)
            }
            if(this.psbTypeIndex == 3){
                this.$refs.ztListView.getStart(this.sendDataDY)
            }
            if(this.psbTypeIndex == 4){
                this.$refs.slListView.getStart(this.sendDataDY)
            }
            if(this.psbTypeIndex == 5){
                this.$refs.fgListView.getStart(this.sendDataDY)
            }
            if(this.psbTypeIndex == 6){
                this.$refs.alListView.getStart(this.sendDataDY)
            }
            if(this.psbTypeIndex == 7){
                this.$refs.jcListView.getStart(this.sendDataDY)
            }
        },
        //税率
        psbChildTypeclickSL(item,index){

        },
        //普适版的 子级的分类切换
        psbChildTypeclick(item,index){
            this.fgShowName = '';
            //选中分类名
            this.showTextChildName = item.name;
            //选中状态
            this.psbChildTypeIndex = index;
            this.dataCount = item.count;
            if(this.psbTypeIndex == 0){
                this.sendDataDY.listId = item.id
                //触发子组件的函数
                setTimeout(() => {
                    this.$refs.dyListView.getStart(this.sendDataDY)
                },100)
            }
            if(this.psbTypeIndex == 2){
                this.sendDataDY.listId = item.id
                //触发子组件的函数
                setTimeout(() => {
                    this.$refs.jdListView.getStart(this.sendDataDY)
                },100)
            }
            if(this.psbTypeIndex == 3){
                this.sendDataDY.listId = item.id
                //触发子组件的函数
                setTimeout(() => {
                    this.$refs.ztListView.getStart(this.sendDataDY)
                },100)
            }
            if(this.psbTypeIndex == 1||this.psbTypeIndex == 5){
                //this.sendDataDY.listId = item.id
                //触发子组件的函数
                //this.$refs.ztListView.getStart(this.sendDataDY)
                //this.fgLeftDataListIndex = 0;
                
                // console.log(item);
                // console.log(tChils);
                this.sendDataDY.listId = item.id;

                let tChils = item.tags||item.childs
                //法规 分类多加个全部
                if(this.psbTypeIndex == 1&&tChils[0].name!='全部'){
                    //效力范围
                    this.getXLFW()
                    //获取所有
                    let newObj = {
                        count:item.count,
                        name:'全部',
                        id:'',
                    }
                    // for(let a =0;a<tChils.length;a++){
                    //     newObj.count+=tChils[a].count;
                    // }
                    tChils.unshift(newObj)
                }
                //效力范围默认全文有效
                this.sendDataDY.states = ['qwyx'];
                //默认左侧选中第一个
                this.fgLeftDataList = tChils
                this.dataLeftTypeClick(tChils[0],0)
            }
            // if(){
            //     //this.sendDataDY.listId = item.id
            //     //触发子组件的函数
            //     //this.$refs.ztListView.getStart(this.sendDataDY)
            //     this.fgLeftDataListIndex = 0;
            //     this.fgLeftDataList = item.childs;
            //     this.fgShowName = item.childs[0].name
            // }
            
            
        },
        //获取法规效力范围
        getXLFW(){
            this.loadingXLFW = true;
            for(let key in this.fgxlfwData){
                //console.log(a)
                this.getDataXLFW(key);
            }
        },
        //获取法规效力范围数据的函数
        getDataXLFW(key){
            let data = {
                categoryId:this.sendDataDY.listId,
                size:1,
                states:[key],
                tagIds:this.sendDataDY.tagIds,
            }

            //判断是否传递了关键词 
            if(this.searchSend.searchType==3){
                data.startPublicDate = this.searchSend.startPublicDate
                data.endPublicDate = this.searchSend.endPublicDate
            }else{
                if(this.searchSend.inputValue&&this.searchSend.inputValue!==''){
                    let key = this.searchSend.searchType==0?'keywordExact':this.searchSend.searchType==1?'title':'articleNo'
                    data[key] = this.searchSend.inputValue
                }
            }

            lawSearch(data).then(res => {
                //console.log(res)
                let tRes = res.data.data
                this.fgxlfwData[key].count = tRes.count;
            })
            setTimeout(() => {
                this.loadingXLFW = false;
            },1000)
        },
        //法规效力范围的点击
        fgxlfwDataClick(item,index){
            this.fgxlfwDataIndex = index;
            this.sendDataDY.states = [this.fgxlfwDataIndex];
            this.$refs.fgListView.getStart(this.sendDataDY)
        },
        //左侧分类选择
        dataLeftTypeClick(item,index){
            this.fgLeftDataListIndex = index;
            this.fgShowName = item.name;
            //法规
            if(this.psbTypeIndex == 1){
                //效力范围
                this.sendDataDY.states = [this.fgxlfwDataIndex];
                this.sendDataDY.tagIds = item.id?[item.id]:[];
                this.getXLFW()
            }else{
                this.sendDataDY.listId = item.id
            }
            //子组件的数据
            setTimeout(() => {
                this.$refs.fgListView.getStart(this.sendDataDY)
            },100)
        },
        //初始展示数据
        getDataAll(){
            let data = {
                withContent:false,
            }
            //判断搜索分类
            if(this.searchSend.searchType == 0&&this.searchSend.inputValue!=''){
                data.keywordExact = this.searchSend.inputValue
            }
            if(this.searchSend.searchType == 1&&this.searchSend.inputValue!=''){
                data.title = this.searchSend.inputValue
            }
            if(this.searchSend.searchType == 2&&this.searchSend.inputValue!=''){
                data.articleNo = this.searchSend.inputValue
            }
            if(this.searchSend.searchType == 3){
                data.startPublicDate = this.searchSend.startPublicDate
                data.endPublicDate = this.searchSend.endPublicDate
            }
            this.loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            HomeLaw(data).then(res => {
                this.dataAll = res.data.data;
                this.$forceUpdate()
                this.dataAll[4].name = '税率'
                this.dataAll[5].name = '实务'
                this.dataAll[6].name = '案例'
                //this.dataAll[7].name = '稽查'

                //2025-09-02 去掉专家答疑
                if(this.dataAll[0].childs[2].name == '专家答疑'){
                    this.dataAll[0].childs.splice(2, 1);
                }
                //2025-09-02 去掉新媒体解读
                if(this.dataAll[2].childs[3].name == '新媒体解读'){
                    this.dataAll[2].childs.splice(3, 1);
                }

                //默认展示的子级数据
                this.psbChildType = this.dataAll[this.psbTypeIndex].childs;
                //默认展示的子级数据条数
                this.dataCount = this.dataAll[this.psbTypeIndex].childs[this.psbChildTypeIndex].count;
                //法规或实务
                if(this.psbTypeIndex == 1||this.psbTypeIndex==5){
                    console.log(this.psbChildTypeIndex)
                    let rData = this.dataAll[this.psbTypeIndex].childs ||this.dataAll[this.psbTypeIndex].children
                    let rrData = rData[this.psbChildTypeIndex].childs || rData[this.psbChildTypeIndex].children || rData[this.psbChildTypeIndex].tags
                    let newObj = {
                        count:rData[this.psbChildTypeIndex].count,
                        name:'全部',
                        id:'',
                    }
                    rrData.unshift(newObj)
                    this.fgLeftDataList = rrData
                }
                this.loading.close()
                
            })
        }

    }
}
</script>
<style lang="scss" scoped>
.bottomWrap{
    width: 1200px;
    margin: 0 auto;
    margin-top: 10px;
}

/***顶部的分类选择 start */
.topType{
    width:100%;
    overflow: hidden;
    background: #fff;
    box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
    padding:20px;
    box-sizing: border-box;
    .typeFlexBox{
        width:100%;
        height:45px;
        display: flex;
        justify-content: space-between;
        .topTypeListCheck{
            background: #0F59A4!important;
            font-weight: 700!important;
            color: #FFFFFF!important;
        }
        .topTypeList{
            width:120px;
            height:45px;
            line-height: 45px;
            text-align: center;
            background: #EEF8FF;
            box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.2);
            font-weight: 400;
            font-size: 20px;
            color: #0F59A4;
            cursor: pointer;
        }
    }
    .childTypeListCheck{
        background: #0F59A4!important;
        color:#ffffff!important;
    }
    .topChildTypeFG{
        width:100%;
        overflow: hidden;
        box-sizing: border-box;
        margin-top:10px;
        .childTypeFGList:nth-child(8n + 8){
            margin-right:0px!important;
        }
        .childTypeFGList{
            width: 120px;
            height: 60px;
            text-align: center;
            background: #EEF8FF;
            border-radius: 4px 4px 4px 4px;
            font-weight: 400;
            font-size: 16px;
            color: #0F59A4;
            float:left;
            box-sizing: border-box;
            cursor:pointer;
            margin-right:28px;
            margin-top:10px;
            .dyChildName{
                margin-top:10px;
            }
            .dyChildTotal{

            }
        }
    }
    .topChildTypeSL{
        width:100%;
        min-height:60px;
        margin-top:10px;
        .childTypeSLList:nth-child(7n + 7){
            margin-right:0px!important;
        }
        .childTypeSLList{
            width: 148px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color:#0F59A4;
            background: #EEF8FF;
            float:left;
            margin-right:20px;
            margin-top:10px;
            border-radius: 4px 4px 4px 4px;
            .dyChildName{
                font-size:16px;
            }
        }
    }
    .topChildTypeDY{
        width:100%;
        height:60px;
        margin-top:20px;
        .childTypeDYList{
            min-width: 148px;
            height: 60px;
            text-align: center;
            border-radius: 4px 4px 4px 4px;
            color:#0F59A4;
            background: #EEF8FF;
            float:left;
            margin-right:20px;
            margin-bottom:10px;
            font-size: 16px;
            padding:0 10px;
            box-sizing: border-box;
            cursor:pointer;
            .dyChildName{
                margin-top:10px;
            }
            .dyChildTotal{

            }
        }
    }
    .fgxlfwView{
        width:100%;
        height:61px;
        border-top:1px solid #eef8ff;
        box-sizing: border-box;
        margin-top:20px;
        padding-top:20px;
        .fgxlfwViewFlex{
            width:100%;
            height:40px;
            display: flex;
            justify-content: space-between;
            .fgxlfwListCheck{
                background: #0F59A4!important;
                font-weight: 700!important;
                color: #FFFFFF!important;
            }
            .fgxlfwList{
                height: 40px;
                line-height: 40px;
                text-align: center;
                background: #EEF8FF;
                border-radius: 20px 20px 20px 20px;
                padding:0 15px;
                color: #0F59A4;
                cursor:pointer;
            }
        }
    }
}
/***顶部的分类选择 end */


/**选中的分类名 start */
.checkNameBox{
    width:100%;
    min-height: 50px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
    font-weight: 400;
    font-size: 18px;
    color: #3D3D3D;
    box-sizing: border-box;
    padding:8px 20px;
    line-height: 32px;
    margin-top:10px;
}
/**选中的分类名 end */


/***数据展示列表  start */
.dataView{
    width:100%;
    overflow: hidden;
    margin-top:10px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
    margin-bottom:50px;
    .dataTopName{
        width:100%;
        height:83px;
        line-height: 82px;
        box-sizing: border-box;
        padding-left:20px;
        border-bottom: 1px solid #d8d8d8;
        font-weight: 700;
        font-size: 18px;
        color: #003FA8;
        .redSpan{
            color:16px!important;
            font-weight: 400!important;
        }
    }
}

.dataViewFG{
    width:100%;
    overflow: hidden;
    margin-top:10px;
    margin-bottom:50px;
    .dataLeftType{
        width: 330px;
        overflow: hidden;
        padding-right:10px;
        box-sizing: border-box;
        float:left;   
        .dataLeftTypeWrap{
            width: 320px;
            height: 1200px;
            background: #FFFFFF;
            box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);       
            overflow-y: auto;
        }
        .dataLeftTypeListCheck{
            background: #003FA8!important;
            color:#fff!important;
            font-weight: 700;
        }
        .dataLeftTypeList{
            width:100%;
            min-height:48px;
            padding:12px 0;
            box-sizing: border-box;
            overflow: hidden;
            margin-bottom:10px;
            background: #EEF8FF;
            cursor:pointer;
            color: #003FA8;
            .leftTypeName{
                width:225px;
                line-height: 24px;
                float:left;
                box-sizing: border-box;
                padding-left:20px;
                font-size: 18px;
            }
            .leftTypeNum{
                width:75px;
                line-height: 24px;
                float:left;
                margin-left:10px;
                font-size: 14px;
                text-align: center;
            }
        }  
    }
    .dataRightCheckNameBox{
        width: 869px;
        height: 50px;
        line-height: 50px;
        box-sizing: border-box;
        padding-left:20px;
        background: #FFFFFF;
        box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
        float:left;
        margin-bottom:13px;
    }
    .fgDataWrap{
        width: 869px;
        float:left;
        background: #FFFFFF;
        box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);
    }
}
/***数据展示列表  end */



.divB{
    width:100%;
    height: 3px;
    background: #0F59A4;
}
.blueSpan{
    color:#003FA8!important;
}
.redSpan{
    color:#C22424!important;
}

</style>